import { render, staticRenderFns } from "./UpdateTrunk.vue?vue&type=template&id=658bd885&"
import script from "./UpdateTrunk.vue?vue&type=script&lang=js&"
export * from "./UpdateTrunk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports